import { filter, set } from 'lodash';

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// material
import { useTheme } from '@mui/material/styles';
import {
    Table,
    Stack,
    TableRow,
    TableBody,
    TableCell,
    Typography,
    TableContainer,
    TablePagination,
    Dialog,
    DialogTitle,
    DialogContent,
    Divider,
    TextField,
    DialogActions,
    Container,
    Autocomplete,
    FormControl,

    RadioGroup,
    FormControlLabel,
    Box,
    Radio,
    FormLabel
} from '@mui/material';
import { Switch } from 'src/@/components/ui/switch';
// redux
import { useDispatch } from 'src/redux/store';

// components
import { UserListHead } from 'src/components/_dashboard/user/list';
import Label from 'src/components/Label';
import Scrollbar from 'src/components/Scrollbar';
import { useSnackbar } from 'notistack';
import useAuth from 'src/hooks/useAuth';

import { TableBorder } from 'src/components/table';
import Iconify from 'src/components/Iconify';
import { HeaderPageComponentConfig } from 'src/components/_dashboard/configuracoes';

// utils
import { fDate, fDateTime } from 'src/utils/formatTime';
import { getTransformEventsWebhook, soNumeros } from 'src/utils/functions';


// zui
import { Button } from 'src/@/components/ui/button';
import { RowInput } from 'src/components/forms/RowInput';
import { Input } from 'src/@/components/ui/input';
import { Textarea } from 'src/@/components/ui/textarea';
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';
import actionListaIntegracoesByCliente from 'src/actions/clientes/actionListaIntegracoesByCliente';
import actionEditarIntegracao from 'src/actions/clientes/actionEditarIntegracao';


export default function Copilot() {
    const { t } = useTranslation('settings');
    const {cliente} = useAuth()
    const navigate = useNavigate();
    const [id, setId] = useState(null);
    const [chatGptStatus, setChatGptStatus] = useState(false)
    const [instrucaoChatgpt, setInstrucaoChatgpt] = useState('');
    const enqueueSnackbar = useSnackbar();


    const buscarListaIntegracoesByCliente = async () => {
        try {
            const response = await actionListaIntegracoesByCliente(cliente._id);

            if (response.data && response.data.data.length > 0) {
                if (response.data.data.some(item => item.resource === "chatgpt")) {
                    let dadosFiltrados = response.data.data.filter(item => item.resource === "chatgpt")[0];
                    setInstrucaoChatgpt(dadosFiltrados.config.instrucao)
                    setChatGptStatus(dadosFiltrados.status)
                    setId(dadosFiltrados._id)
                }
            }
        } catch (error) {
            console.log('error', error)
        }
    }

    const editarConfigChatGpt = async () => {
        try {
          let data = {
            scope: {
              clienteId: cliente._id,
              status: chatGptStatus,
              intrucao: instrucaoChatgpt
            },
            action: "editar_chatgpt",
          }
          await actionEditarIntegracao(id, data);
          enqueueSnackbar(t('integrations.copilot.saveSuccess', 'Configuração salva com sucesso'), { variant: 'success' });
          buscarListaIntegracoesByCliente();
    
        } catch (error) {
          console.log('error', error)
        }
      }

    useEffect(() => {
        buscarListaIntegracoesByCliente()
      return () => {
        setChatGptStatus(null);
        setInstrucaoChatgpt('');
        setId(null);
      }
    }, [])
    




    return (
        <Box>
            <Container maxWidth="lg">
                <HeaderPageComponentConfig
                    // backAction={() => navigate(-1)}
                    titulo="Copilot"
                    descricao={t('integrations.copilot.description', 'Configure o Copilot para gerar respostas automáticas baseadas em IA')}
                />

                <div className='flex gap-6 flex-col w-2/3 mt-6'>

                    <RowInput
                        label={t('labels.status', { ns: 'common' })}
                        input={<Switch
                            checked={chatGptStatus}
                            defaultValue={chatGptStatus}
                            onChangeChecked={e => setChatGptStatus(e)}
                            inputProps={{ 'aria-label': 'controlled' }}
                        />}
                    />

                    <RowInput
                        label={t('integrations.copilot.promptLabel', 'Prompt')}
                        input={<Textarea
                            value={instrucaoChatgpt}
                            onChange={e => setInstrucaoChatgpt(e.target.value)}
                            multiline
                            rows={4}
                        />}
                    />

                    <ButtonLoading
                        className="w-1/3 bg-slate-600"
                        loading={false}
                        onClick={editarConfigChatGpt}
                    >
                        {t('buttons.save', { ns: 'common' })}
                    </ButtonLoading>
                </div>

            </Container>

        </Box>
    );
}
